import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { FloatingFocusManager, FloatingPortal } from '@floating-ui/react'
import useInlineFloatingMenu from '../../../hooks/useInlineFloatingMenu'
import SwatchPicker from './SwatchPicker'

const POPOVER_CLASS = 'tw:z-[1100] tw:bg-white tw:rounded-md! tw:p-3 tw:shadow-ds-popover!'
const TITLE_CLASS = 'tw:text-xs tw:font-medium tw:text-gray-700 tw:mt-0! tw:mb-3!'

const ColorPopover = ({ anchorEl, isOpen, colors, value, onSelect, onClose }) => {
  const { refs, floatingStyles, context, getFloatingProps } =
    useInlineFloatingMenu({ anchorEl, isOpen, onClose })

  const handleSelect = useCallback(color => {
    onSelect(color)
    onClose()
  }, [onSelect, onClose])

  if (!isOpen || !anchorEl)
    return null

  return (
    <FloatingPortal>
      <FloatingFocusManager context={context} initialFocus={-1} modal={false}>
        <div
          ref={refs.setFloating}
          aria-label="Choisir la couleur"
          className={POPOVER_CLASS}
          style={floatingStyles}
          {...getFloatingProps()}
        >
          <p className={TITLE_CLASS}>Choisir la couleur</p>
          <SwatchPicker colors={colors} value={value} onSelect={handleSelect} />
        </div>
      </FloatingFocusManager>
    </FloatingPortal>
  )
}

ColorPopover.propTypes = {
  anchorEl: PropTypes.instanceOf(Element),
  colors: PropTypes.arrayOf(PropTypes.string).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  value: PropTypes.string
}

ColorPopover.defaultProps = {
  anchorEl: null,
  value: null
}

export default ColorPopover
